<template>
	<div class="container table-responsive">
		<h5>Artist</h5>
		<table id="cart" class="table table-hover table-sm">
			<thead>
			<tr>
				<th style="width:50%">Singer</th>
				<th style="width:10%">Account</th>
				<th style="width:8%">Balance</th>
				<th style="width:22%" class="text-center">HBar</th>
				<th style="width:10%">Email</th>
			</tr>
			</thead>

			<transition-group name="list-shopping-cart" tag="tbody">
				<app-singer-item
						:singer="singer"
						:token="singerTokens"
						:key="singer.id"
				></app-singer-item>
			</transition-group>

		</table>

		<hr>
		<br><br>
		<h5>My Account</h5>

		<table class="table">
			<thead>
			<tr>
				<th>Email</th>
				<th>Account</th>
				<th>Balance</th>
				<th>Hbar</th>
			</tr>
			</thead>
			<tbody>
			<tr>
				<td>{{ account.wallet }}</td>
				<td>{{ account.accountId }}</td>
				<td>{{ tokens[0].balance }}</td>
				<td>{{ tokens[0].hbarBalance }}</td>
			</tr>
			</tbody>
		</table>
		<hr>
		<form class="form-inline">
			<div class="form-group mb-2">
				<input type="number" class="form-control" @input="updateValue">
			</div>
			<button type="submit" class="btn btn-primary mx-sm-2 mb-2" @click.prevent="sendToken">Send Token
			</button>
		</form>
	</div>
</template>

<script>
	import { accountGetInfo } from "@/service/accountInfo";
	import TokenList from "@/components/token/TokenList";
	import SingerItem from "@/components/singer/SingerItem";
	import { tokenTransfer } from "@/service/tokenService";
	import { EventBus } from "@/eventBus";


	export default {
		data() {
			return {
				account: this.$store.getters.getCurrentAccount,
				tokens: {},
				singer: this.$store.getters.selectedSinger,
				singerTokens: {},
				sendAmount: 0
			}
		},
		methods: {
			async getTokens() {
				const resultTokens = [];
				const tokenRelationships = await accountGetInfo(this.account.accountId);
				for (const key in tokenRelationships) {
					const tokenRelationship = tokenRelationships[key];
					resultTokens.push(tokenRelationship);
				}
				this.tokens = resultTokens;
			},
			async getSingerTokens() {
				const resultTokens = [];
				const tokenRelationships = await accountGetInfo(this.singer.accountId);
				for (const key in tokenRelationships) {
					const tokenRelationship = tokenRelationships[key];
					resultTokens.push(tokenRelationship);
				}
				this.singerTokens = resultTokens;
				console.log('SingerDetail.vue getSingerToken');
				console.log(this.singerTokens);
			},
			sendToken() {
				const tokenId = this.tokens[0].tokenId;
				const quantity = this.sendAmount;
				const hbar = 0;
				const destination = {
					accountId: this.singer.accountId,
					privateKey: this.singer.privateKey,
					wallet: this.singer.wallet
				}

				tokenTransfer(tokenId, this.account, quantity, hbar, destination)
						.then(result => {
							console.log('token transfer result: ' + result);
							if (result) {
								this.getTokens();
								EventBus.$emit('updateToken', true);
							}
						})
			},
			updateValue(event) {
				this.sendAmount = event.target.value;
			}
		},
		components: {
			appSingerItem: SingerItem,
			appTokenList: TokenList
		},
		created() {
			this.getTokens();
			this.getSingerTokens();
		}
	}
</script>

<style scoped>

</style>